import React, {useState, useEffect} from "react";
import { useLocation } from 'react-router-dom';
import services from "./services.js" 
import {config} from "./config.js";

const Unsubscribe = (props) => {

  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);

  let location = useLocation();
  let {pathname, search} = location
  
  pathname = pathname ? pathname.replace("/","").toLowerCase() : ""
  search = search ? search.replace("?", "") : ""
  
  let data = {}
  try {
    data = JSON.parse('{"' + decodeURI(search.replace(/&/g, "\",\"").replace(/=/g,"\":\"")) + '"}')
  } catch (error) {
    data = {}
  }

  useEffect(() => {
    
    if(pathname === "unsubscribe"){

      services.post("/notification/unsubscribe", data)
      .then((response) => {
        setSuccess(response.success)
        setMessage(response.message)
      })
      .catch(error =>  setMessage(error.toString()))

    }else if(pathname === "unsubscribeall"){

      services.post("/notification/unsubscribeAll", data)
      .then((response) => {
       setSuccess(response.success)
       setMessage(response.message)
  
      })
      .catch(error =>  setMessage(error.toString()))
    }

    setTimeout(() => {
     window.location.replace(config.front)         
    }, 5000);
  },[]);

  return (
    <section style={{background : "white"}}>
      <div className="card secondary" style={{textAlign : "center"}}>
        
        {success ?

          <p style={{color : "green"}}>
            {message ? message : ""}
          </p>

        :

        <p style={{color : "red"}}>
          {message ? message : ""}
        </p>

        }
        
       
      </div>
    </section>
  );
};

export default Unsubscribe;
